import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  Inject,
  InjectionToken,
  OnInit,
  Optional,
} from '@angular/core';
import { Observable } from 'rxjs';

import { API_BASE_URL } from '../../../../api/api-reference';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-health-check',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './health-check.component.html',
  styleUrl: './health-check.component.scss',
})
export class HealthCheckComponent{
  public FrontVersion: string = environment.githubSha;
  public MeterOpsVersion: string = '';
  public UserOpsVersion: string = '';
  public baseUrl: string = '';
  public address: string = '';
  public API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
  private http: HttpClient;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
    const url = new URL(this.baseUrl);
    this.address = url.hostname;

    this.helloUser().subscribe(
      (response) => (this.UserOpsVersion = response),
      (error) => console.error('helloUser Error:', error),
    );

    this.helloMeter().subscribe(
      (response) => (this.MeterOpsVersion = response),
      (error) => console.error('helloMeter Error:', error),
    );
  }

  helloUser(): Observable<any> {
    const url_ = `${this.address}:8123/api/Hello`;

    const options_ = {
      headers: new HttpHeaders({ Accept: 'application/json' }),
      responseType: 'text' as 'json', // <- Fix this to handle text responses
    };

    return this.http.get(url_, options_);
  }

  helloMeter(): Observable<any> {
    const url_ = `${this.address}:8124/api/Hello`;

    const options_ = {
      headers: new HttpHeaders({ Accept: 'application/json' }),
      responseType: 'text' as 'json',
    };

    return this.http.get(url_, options_);
  }
}
